import {callAPI} from '../../api/rest/callApi';
import {API_EMPLOYEE_REVIEW_SAVE_REVIEW} from '../../const/Api';
import {
  ALERT_VARIANT,
  EQuestionCategory,
  NotQualifiedMessage,
  QUESTION_TYPE,
  RestApiMethod,
} from '../../const/dataEnum';
import {setAlert} from '../actions/alertModalStateAction';

export const saveReview = async (dispatch, data = {}) => {
  const {steps, myReview} = data;
  const generic = [];
  const skill = [];
  steps.forEach((step) => {
    step.content.question.forEach((q) => {
      if (q.category === EQuestionCategory.GENERAL) {
        generic.push({
          genericReviewQuestionID: q.questionID,
          score: q.score,
          comments: q.comments,
        });
      }

      if (q.category === EQuestionCategory.SKILL) {
        skill.push({
          skillID: q.questionID,
          score: q.score,
          comments: q.comments,
        });
      }
    });
  });
  if (generic.length === 0 && skill.length === 0) return;
  let param = {
    id: myReview.id,
    reviewedByID: myReview.reviewedByID,
    employeeReviewedID: myReview.employeeReviewedID,
    reviewPeriodID: myReview.reviewPeriodID,
    reviewTypeID: myReview.reviewTypeID,
    projectID: myReview.projectID,
    employeeSkillReviews: skill,
    employeeGenericReviews: generic,
  };
  const res = await callAPI({
    url: API_EMPLOYEE_REVIEW_SAVE_REVIEW,
    method: RestApiMethod.POST,
    data: param,
  });
  if (res.data.responseCode !== 0) {
    dispatch(
      setAlert({
        show: true,
        variant: ALERT_VARIANT.ERROR,
        message: 'Failed to auto save review task',
      })
    );
  }
};

const getWordCount = (text) => {
  if (!text || !text.trim || typeof text !== 'string') {
    return 0;
  }
  return text.trim().split(/\s+/).filter(Boolean).length;
};

const getUnansweredMandatoryEssayQuestion = (isGeneral, reviews) => {
  const mandatoryQuestion = reviews.filter((review) => review.required && review.questionType === QUESTION_TYPE.ESSAY);
  let unansweredQuestion = [];

  if (isGeneral) {
    unansweredQuestion = mandatoryQuestion.filter((review) => {
      if (review.isNotQualified) return false;
      const comment = review.comments?.trim?.() || '';
      if (!comment || (review.commentsRequired && getWordCount(comment) < review.minimumofWords)) {
        return true;
      }
      return false;
    });
  } else {
    unansweredQuestion = mandatoryQuestion.filter((review) => {
      if (review.isNotQualified) return false;
      const comment = review.comments?.trim?.() || '';
      if (
        (!comment && review.comments !== NotQualifiedMessage) ||
        (comment && review.commentsRequired && getWordCount(comment) < review.minimumofWords)
      ) {
        return true;
      }
      return false;
    });
  }

  return unansweredQuestion;
};

const getUnansweredMandatoryScoreQuestion = (isGeneral, reviews) => {
  const mandatoryQuestion = reviews.filter((review) => review.required && review.questionType !== QUESTION_TYPE.ESSAY);
  let unansweredQuestion = [];

  if (isGeneral) {
    unansweredQuestion = mandatoryQuestion.filter((review) => {
      if (review.isNotQualified) return false;
      const comment = review.comments?.trim?.() || '';
      const scoreValid = Number.isFinite(review.score) && review.score > 0;
      if (review.commentsRequired) {
        if (!scoreValid || !comment || getWordCount(comment) < review.minimumofWords) {
          return true;
        }
      }

      if (!review.commentsRequired) {
        if (!scoreValid) {
          return true;
        }
      }

      return false;
    });
  } else {
    unansweredQuestion = mandatoryQuestion.filter((review) => {
      if (review.isNotQualified) return false;
      const comment = review.comments?.trim?.() || '';
      const scoreValid = Number.isFinite(review.score) && review.score > 0;

      if (review.commentsRequired) {
        if (!scoreValid || !comment || getWordCount(comment) < review.minimumofWords) {
          return true;
        }
      }

      if (!review.commentsRequired) {
        if (!scoreValid && review.comments !== NotQualifiedMessage) {
          return true;
        }
      }
      return false;
    });
  }

  return unansweredQuestion;
};

export const isReviewCompleted = (isGeneral, reviews) => {
  let totalUnansweredMandatoryEssayQuestionGeneral = getUnansweredMandatoryEssayQuestion(true, reviews).length;
  let totalUnansweredMandatoryScoreQuestionGeneral = getUnansweredMandatoryScoreQuestion(true, reviews).length;

  let totalUnansweredMandatoryEssayQuestionSkill = getUnansweredMandatoryEssayQuestion(false, reviews).length;
  let totalUnansweredMandatoryScoreQuestionSkill = getUnansweredMandatoryScoreQuestion(false, reviews).length;

  if (
    totalUnansweredMandatoryEssayQuestionGeneral === 0 &&
    totalUnansweredMandatoryScoreQuestionGeneral === 0 &&
    totalUnansweredMandatoryEssayQuestionSkill === 0 &&
    totalUnansweredMandatoryScoreQuestionSkill === 0
  ) {
    return true;
  }

  return false;
};

export const hasQuestionAnswered = (question) => {
  if (question.questionType === QUESTION_TYPE.ESSAY) {
    if (!question.required || question.comment === NotQualifiedMessage) {
      return true;
    }
    if (question.comment) {
      if (!question.commentsRequired) {
        return true;
      }
      if (question.commentsRequired && getWordCount(question.comment) >= question.minimumofWords) {
        return true;
      }
    }
    return false;
  }

  if (!question.required) {
    if (question.comment === NotQualifiedMessage || (Number.isFinite(question.score) && question.score > 0) || question.comment) {
      return true;
    }
  }

  if (question.required && !question.commentsRequired) {
    if ((Number.isFinite(question.score) && question.score > 0) || question.comment === NotQualifiedMessage) {
      return true;
    }
  }

  if (question.required && question.commentsRequired) {
    if ((Number.isFinite(question.score) && question.score > 0) && question.comment && getWordCount(question.comment) >= question.minimumofWords) {
      return true;
    }
  }

  return false;
};

export const showButtonClear = (question) => {
  if ((question.score || question.comment) && question.comment !== NotQualifiedMessage) {
    return true;
  }
  return false;
};
